import { Link as RouterLink } from 'react-router-dom';

export const Link = ({ children, ...rest }) => {
  return (
    <RouterLink {...rest}>
      {children}
    </RouterLink>
  );
};
